import { render } from "./RouteLimitExceeded.vue?vue&type=template&id=53aacee0&scoped=true"
import script from "./RouteLimitExceeded.vue?vue&type=script&lang=ts"
export * from "./RouteLimitExceeded.vue?vue&type=script&lang=ts"

import "./RouteLimitExceeded.vue?vue&type=style&index=0&id=53aacee0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-53aacee0"

export default script